export const TYPE_METRIC = 'metric';
export const TYPE_COHORT_METRIC = 'cohortMetric';
export const TYPE_DECIMAL = 'decimal';
export const TYPE_BRACKET_OPEN = 'bracketOpen';
export const TYPE_BRACKET_CLOSE = 'bracketClose';
export const TYPE_OPERATOR = 'operator';

export const OPERATOR_ADD = '+';
export const OPERATOR_SUBTRACT = '-';
export const OPERATOR_MULTIPLY = '*';
export const OPERATOR_DIVIDE = '/';

export const EMPTY_DECIMAL = '{EMPTY}';

export const BRACKET_OPEN = '(';
export const BRACKET_CLOSE = ')';
